    <div class="row default-dadhboard">

      <div class="col-md-6 col-xl-3">
        <div class="card-box tilebox-one" style="height:200px">
          <i class="mdi mdi-shopping float-right"></i>
          <h5 class="text-muted text-uppercase mb-3 mt-0">Merchants</h5>
          <h3 class="mb-3" data-plugin="counterup">{{merchantCount}}&nbsp;<label>Merchants</label></h3>
          <br />
          <span class="badge badge-primary"> {{merchantCount}} </span> <span class="text-muted ml-2 vertical-middle"> Total merchants registered</span>
          <br />
        </div>
      </div>

      <div class="col-md-6 col-xl-3">
        <div class="card-box tilebox-one" style="height:200px">
          <i class="fe-shopping-cart float-right"></i>
          <h5 class="text-muted text-uppercase mb-3 mt-0">Terminals</h5>
          <h3 class="mb-3">
            <span data-plugin="counterup">{{activeTerminal}}</span>&nbsp;<label>Active terminals</label>
            <br />
            &nbsp;&nbsp;<span data-plugin="counterup">{{inactiveTerminal}}</span>&nbsp;<label>In-active terminals</label>
          </h3>
          <span class="badge badge-primary"> {{totalTerminals}} </span> <span class="text-muted ml-2 vertical-middle">Total terminals</span>
        </div>
      </div>

      <div class="col-md-6 col-xl-3">
        <div class="card-box tilebox-one" style="height:200px">
          <i class="fe-user float-right"></i>
          <h5 class="text-muted text-uppercase mb-3 mt-0">Users</h5>
          <span class="text-muted ml-2 vertical-middle"><b><u>User activity for current</u> &nbsp;&nbsp;&nbsp;<u>participant</u></b></span><br />
          <ul *ngIf="!!participantLogins && participantLogins.length > 0">
            <li *ngFor="let login of participantLogins" style="font-size:12px;">{{login.user}}: {{login.date | date: 'medium'}}</li>
          </ul>
          <h3 class="mb-3" *ngIf="!participantLogins || participantLogins.length <= 0"><span class="not-found">No User Activity Found</span></h3>
        </div>
      </div>

      <div class="col-md-6 col-xl-3">
        <div class="card-box tilebox-one" style="height:200px">
          <i class="fe-monitor float-right"></i>
          <h5 class="text-muted text-uppercase mb-3 mt-0">Audit trail</h5>
          <span class="text-muted ml-2 vertical-middle"><b><u>Last action performed:</u></b></span><br />
          <div>
            <ul>
              <li><span style="font-size:12px;">{{data}}</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row default-dadhboard">

      <div class="col-md-8">
        <h2>Helpdesk Contact Details</h2>
        <p>The ACS helpdesk operates during the following hours: </p>
        <ul>
          <li>Monday to Friday: 7h00 - 18h00</li>
          <li>Saturdays and Public Holidays: 8h00 - 13h00</li>
        </ul>
        <p><strong>Please note</strong> outside operating hours calls should be logged via email. (<a href="mailto:acshelp@acs-sa.com">acshelp@acs-sa.com</a>)</p>
        <table class="table">
          <thead>
            <tr>
              <th>Contact</th>
              <th>Contact Number</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>During Operating Hours</td>
              <td>021 200 0451</td>
              <td><a href="mailto:acshelp@altron.com">acshelp@altron.com</a></td>
            </tr>
            <tr>
              <td>Outside Operating Hours</td>
              <td></td>
              <td><a href="mailto:acshelp@altron.com">acshelp@altron.com</a></td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
